<template>
  <div class="Protrain">
    <div class="cs-Protrain-part1">
      <div class="container">
        <h1>专业培训</h1>
        <div class="item">
          <div class="item-1"><img src="../assets/img/zhaunyeoeixun.jpg" alt=""></div>
          <div class="item-2"><img src="../assets/img/zhaunyepeixun_1.jpg" alt=""></div>
          <div class="item-3"><img src="../assets/img/cs-protrain-1.jpg" alt=""></div>
          <div class="item-4"><img src="../assets/img/cs-protrain-2.jpg" alt=""></div>  
        </div>
        <div class="text-column">
            <div class="item-5"><img src="../assets/img/cs-protrain-3.jpg" alt=""></div>
            <div class="word-text">
              <p class="p1">2020年公司与武汉大学合作建成的武汉大学的 RTC（区域教育培训中心）<br>每年将在此举办湖北地区教师培训，邀请多个高校的老师参加。</p>
              <p class="p2">咨询邮箱：edu@jschuangsen.cn</p>
            </div>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>

    <!-- 区域培育培训中心 -->
    <div class="cs-Protrain-part2">
      <div class="container">
        <div class="part-con">
          <p class="p1">区域教育培训中心<br>(Regional Training Center，简称 RTC)</p>
          <p class="p2" style="letter-spacing:0.3px">是一个面向大中华区专门将 Apple 专业培训课程融入其面向注册学员的既定教程和管理认证中的学术机构。本计划的设计十分灵活，提供 Apple 专业培训系列教材以增强现有的教程。RTC 通过符合 Apple 要求的 Apple 认证培训师向学员和教员教授 Apple 专有课程。</p>
          <p class="p3">Apple 培训班具有可扩展性，能够满足教育机构在正常学期长度班级内的需求，而且是当前创新课程计划的完美补充。</p>
          <img src="../assets/img/cs-protrain-4.jpg" alt="">
        </div>
      </div>
    </div>

    <div class="cs-Protrain-part3">
      <div class="container">
        <h1>RTC 对教育合作机构的价值</h1>
        <h2>Apple 面向 RTC (区域教育培训中心)提供以下支持:</h2>

        <!-- 1 -->
        <div class="item">
          <div class="grid-content item-1">
            <img src="../assets/img/icon-protrain-1.png" alt="">
            <p class="tit">Apple 认证授牌。 </p>
            <p class="con">所有通过审核和认证的学术机构，都将会被授予 “区域教育培训中心” 标牌和证书，学术机构可以在后续的营销传播和商务活动中使用这些标牌和证书。(在 RTC (区域教育培训中心）合同规定范围内合理使用 Apple 的名称或任何其他的商标、商品名称，销售名称，标志，版权和任何声称仅限 Apple 使用的其他知识产权。</p>
          </div>
          <div class="grid-content item-2">
            <img src="../assets/img/icon-protrain-2.png" alt="">
            <p class="tit">专业培训教室建设指导。</p>
            <p class="con">Apple 会提供培训教室布局、硬件配置和技术搭建指导，以及日常运营管理和维护的指导。</p>
          </div>
        </div>

        <!-- 2 -->
        <div class="item">
          <div class="grid-content item-3">
            <img src="../assets/img/icon-protrain-3.png" alt="">
            <p class="tit">讲师培训支持。</p>
            <p class="con">Apple 将定期举办面向 RTC (区域教育培训中心) 讲师的培训，以帮助讲师深刻把握最新技术和课程内涵，并获得/更新各类认证，从而更好地胜任培训工作。同样，也 会对相应的 IT 支持人员进行类似的技术培训。</p>
          </div>
          <div class="grid-content item-4">
            <img src="../assets/img/icon-protrain-4.png" alt="">
            <p class="tit">课程开发以及评估专家的支持。</p>
            <p class="con">RTC (区域教育培训中心) 教学专家委员会，包括 Apple 杰出教育工作者(ADE)，Apple 教育认证讲师(APD) 将会对 RTC (区域教育培训中心) 的讲师提供课程定期指导与支持，以帮助 RTC (区域教育培训中心) 讲师开发定制自己的高级学科课程。</p>
          </div>
          <div class="grid-content item-5">
            <img src="../assets/img/icon-protrain-5.png" alt="">
            <p class="tit">建立 RTC (区域教育培训中心) 交流平台。</p>
            <p class="con">通过本计划和各类活动如APD (Apple 教育培训认证讲师) 培训，RTC (区域教育培训中心) 讲座，可以建立起全球同行学习交流和合作，分享经验，促进彼此的共同进步。</p>
          </div>
        </div>

        <!-- 3 -->
        <div class="item">
          <div class="grid-content item-6">
            <img src="../assets/img/icon-protrain-6.png" alt="">
            <p class="tit">课程内容支持。</p>
            <p class="con">Apple 提供基础以及高级课程内容给 RTC (区域教育培训中心)。</p>
          </div>
          <div class="grid-content item-7">
            <img src="../assets/img/icon-protrain-7.png" alt="">
            <p class="tit">多层次营销支持。</p>
            <p class="con">Apple 会对 RTC (区域教育培训中心)运营团队提供基本的营销技能培训，并提供与 Apple 授权经销商 合作的机会，以帮助 RTC (区域教育培训中心) 提升知名度、品牌影响力。</p>
          </div>
          <div class="grid-content item-8">
            <img src="../assets/img/icon-protrain-8.png" alt="">
            <p class="tit">有机会参与国际交流。</p>
            <p class="con">优秀的 RTC (区域教育培训中心)将有机会与世界范围内的 RTC (区域教育培训中心) 展开国际交流， 并将多元的国际教育经验融入到自己的日常运营中。</p>
          </div>
        </div>
      </div>

      
    </div>

    <div class="cs-Protrain-part4">
      <div class="container">
        <h1>成为 RTC 需要具备的资质条件</h1>
        <p class="p1">为学员提供更切合实际的教育内容。教授他们使用 Apple 创新的专业解决方案。对他们的技能进行认证。关注他们通过将 Apple 解决方案作为其创新创意工具，帮助他们事业成功。RTC（区域教育培训中心）资质要求如下，更详细的信息请参阅附录的资质要求表格:</p>
        <div class="item">
          <div class="item-1">
            <img src="../assets/img/cs-protrain-5.jpg" alt="">
            <p class="p2">场地要求。</p>
            <p class="p3">至少1间可以同时安排 30-50 位学员进行课桌式学习的培训教室，人均面积建议不少于2平方米。</p>
          </div>
          <div class="item-2">
            <p class="p4">设备要求。</p>
            <p class="p5">每个学员至少拥有1台 iMac 或 MacBook 笔记本, 以及1台 iPad 供上课时使用；以及1-2套独立的讲师设备。</p>
            <img src="../assets/img/teacherTrain-1.png" alt="">
          </div>
        </div>

        <div class="item-3">
          <img src="../assets/img/icon-protrain-9.png" alt="">
          <p class="p6">人员要求。</p>
          <p class="p7">每个 RTC(区域教育培训中心)要求至少拥有1名全职讲师，参加并完成 Apple 师资培训，并需要于六个月内成功教授一门学分课程以取得 APD(Apple 教育培训认证讲师) 资格认证；建议每个 RTC(区域教育培训中心)至少配备1名专职 IT 支持人员，以对 RTC(区域教育培训中心)教室和设备进行定期的管理与技术维护；建议每个 RTC(区域教育培训中心)至少配备1名专职的运营管理人员，全面负责整个 RTC (区域教育培训中心)的日常运营工作。我们每个季度会定期在北上广三个城市举行师资培训，RTC全职讲师需要在六个月成功教授一门学分课程以取得 APD(Apple 教育培训认证讲师）。</p>
        </div>
      </div>
    </div>

    <div class="cs-Protrain-part5">
      <div class="container">
        <el-row class="bgcol">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <template>
              <el-carousel :interval="5000" height="540px" arrow="always">
                <el-carousel-item>
                  <h3>申请成为 RTC 的流程</h3>
                  <p>在收到合作伙伴的申请后，我们会组织专家委员会，对合作伙伴的申请进行评估和审核，并根据需要组织现场教室验收。</p>
                </el-carousel-item>
                <el-carousel-item>
                  <h3>第一步：资质准备。</h3>
                  <p>根据我们的资质要求表格，建立至少1间标准培训教室并安排讲师完成培训。建议准备 IT 支持人员和运营人员。</p>
                </el-carousel-item>
                <el-carousel-item>
                  <h3>第二步：提出申请。</h3>
                  <p>使用我们标准的申请表格提出申请。</p>
                </el-carousel-item>
                <el-carousel-item>
                  <h3>第三步：审批标准。</h3>
                  <p>在收到合作伙伴的申请后，我们会组织专家委员会，对合作伙伴的申请进行评估和审核，并根据需要组织现场教室验收。</p>
                </el-carousel-item>
                <el-carousel-item>
                  <h3>第四步：授予标牌。</h3>
                  <p>评估后符合条件的合作伙伴，会授予区域教育培训中心标牌和证书。</p>
                </el-carousel-item>
                <el-carousel-item>
                  <h3>第五步：授权更新。</h3>
                  <p>Apple 每年定期两次对 RTC(区域教育培训中心)进行评估审核。</p>
                </el-carousel-item>
              </el-carousel>
            </template>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <img src="../assets/img/cs-protrain-7.jpg" alt="">
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="cs-Protrain-part6">
      <div class="container">
        <p class="p1">如何对 RTC 进行运营考核</p>
        <p class="p2">RTC（区域教育培训中心）为了保证 RTC（区域教育培训中心）的培训质量和运营服务水准，我们会每半年对 RTC（区域教育培训中心）培训中心进行评估和考核。考核形式以书面考核为主，现场评估为辅。每次评估审核，RTC（区域教育培训中心）需要向 Apple 汇报当年运营报告，包括场次数量和学员数量等。</p>
      </div>
    </div>

    <div class="cs-page">
      <router-link to="home" active-class="activeClass">首页</router-link>
      <router-link to="iOSCourse" active-class="activeClass">下一页</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name:'Protrain',
  data() {
    return {
    }
  },
  mounted(){
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.Protrain{
   border-bottom: 1px solid #D6D6D6;
    .cs-Protrain-part1{
      background: #f5f5f7;
      text-align: center;
      h1{
        font-size: 58px;
        font-weight: 600;
        color: #000000;
        line-height: 76px;
        padding: 115px 0 104px 0;
      }
      .item{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        justify-items: baseline;
        .item-1,.item-2,.item-3,.item-4{
          width: 100%;
          border-radius: 22px;
          overflow: hidden;
        }
        
      
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
    }
   .text-column{
           display: flex;
           justify-content: space-around;
           align-items: center;
           margin-top: 30px;
          .item-5{
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 100%;
            height: auto;
            margin-bottom: 20px;
            border-radius: 22px;
            display: block;
          }
        }
         .word-text{
            display: flex;
            flex-direction: column;
            justify-content: center;        
        }
          .p1{
            font-size: 24px;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            margin-bottom: 60px;
          }
          .p2{
            font-size: 32px;
            font-weight: 500;
            color: #000000;
            line-height: 38px;
            margin: 0;
          }
        }
  .cs-Protrain-part2{
    background: #ffff;
    padding: 63px 0;
    .part-con{
      background: #E5FCF4;
      border-radius: 22px;
      overflow: hidden;
      color: #000000;
      text-align: center;
      .p1{
        font-size: 36px;
        line-height: 55px;
        font-weight: 600;
        padding: 50px 120px 50px 120px;
      }
      .p2{
        font-size: 20px;
        line-height: 38px;
        padding: 0 120px;
        word-break: break-word;
        text-align: justify;
      }
      .p3{
        font-size: 20px;
        line-height: 38px;
        padding: 55px 120px 58px 120px;
        text-align: left;
      }
      img{
        margin: 0;
        float: left;
        max-width: 100%;
      }
    }
  }

  .cs-Protrain-part3{
      background: #f5f5f7;
      h1{
        font-size: 42px;
        font-weight: 600;
        color: #000000;
        line-height: 38px;
        text-align: center;
        padding: 81px 0 59px 0;
      }
      h2{
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 38px;
        text-align: center;
        margin-bottom: 62px;
      }
      .item{
        display: flex;
        margin-bottom: 30px;
        //  背景颜色-标题-内容
        .grid-content {
          background: #FFFFFF;
          border-radius: 22px;
          float: left;
          width: 380px;
          margin: 0 15px;
          word-break: break-word;
          &:first-child{
            margin-left: 0;
          }
          &:last-child{
            margin-right: 0;
          }
          .tit{
            font-size: 26px;
            font-weight: 600;
            color: #000000;
            line-height: 38px;
          }
          .con{
            font-size: 20px;
            font-weight: 400;
            color: #000000;
            line-height: 48px;
            text-align: justify;
          } 
        }
        .item-1{
          width: 790px;
          padding: 51px 45px 48px 45px;
          .tit{
            margin: 48px 0 22px 0;
          }
          img{
            max-width: 100%;
          }
        }
        .item-2{
          width: 380px;
          padding: 50px 39px 0 37px;
          .tit{
            margin: 46px 0 26px 0;
          }
        }
        .item-3{
          padding: 61px 39px 0 37px;
          .tit{
            margin: 30px 0 24px 0;
          }
        }
        .item-4{
          padding: 48px 37px 46px 37px;
          .tit{
            margin: 36px 0px 21px 0px;
          }
        }
        .item-5{
          padding: 54px 39px 0px 38px;
          .tit{
            margin: 44px 0px 20px 0px;
          }
        }
        .item-6{
          padding: 61px 39px 0px 37px;
          .tit{
            margin: 40px 0px 24px 0px;
          }
        }
        .item-7{
          padding: 57px 37px 53px 37px;
          .tit{
            margin: 39px 0px 23px 0px;
          }
        }
        .item-8{
          padding: 53px 39px 0px 38px;
          .tit{
            margin: 32px 0px 24px 0px;
          }
        }
      }
      
      
  }

  .cs-Protrain-part4{
    background: #FFFFFF;
    padding: 0 0 91px 0;
    h1{
      font-size: 42px;
      font-weight: 600;
      color: hsl(0, 0%, 0%);
      line-height: 50px;
      text-align: center;
      padding: 90px 0 60px 0;
    }
    .p1{
      font-size: 20px;
      font-weight: 400;
      color: #000000;
      line-height: 38px;
      text-align: center;
      padding-bottom: 42px;
      max-width: 958px;
      margin: 0 auto;
    }
    .item{
      display: flex;
      padding-bottom: 60px;
      img{
        max-width: 100%;
        max-height: 100%;
        &:first-child{
          max-width: none;
        }
      }
      .p2,.p4{
        font-size: 26px;
        font-weight: 600;
        color: #000000;
        line-height: 38px;
      }
      .p3,.p5{
        font-size: 20px;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
      }
      .item-1{
        width: 570px;
        position: relative;
        background: #F5F5F7;
        border-radius: 22px;
        overflow: hidden;
        margin-right: 60px;
        .p2{
          position: absolute;
          left: 56px;
          top: 52px;
          width: 456px;
          color: #FFFFFF;
        }
        .p3{
          position: absolute;
          left: 0;
          top: 100px;
          width: 100%;
          padding: 0 55px;
          color: #FFFFFF;
        }
      }
      .item-2{
        width: 570px;
        padding: 48px 56px 0 55px;
        background: #F5F5F7;
        border-radius: 22px;
        overflow: hidden;
        text-align: center;
        p{
          text-align: left;
        }
        .p5{
          margin:28px 0 58px 0;
          text-align: justify;
        }
      }
    }
    .item-3{
      background: #F5F5F7;
      border-radius: 22px;
      padding: 57px 120px 57px 121px;
      .p6{
        font-size: 26px;
        font-weight: 600;
        color: #000000;
        line-height: 38px;
        margin: 30px 0 26px 0;
      }
      .p7{
        font-size: 20px;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        text-align: justify;
      }
    }
  }
  .cs-Protrain-part5{
    background: #f5f5f7;
    padding: 80px 0;
    .container{
      .bgcol{
        border-radius: 22px;
        background: #DEEDF4;
        overflow: hidden; 
      }
      img{
        float: left;
        width: 100%;
      }
      .el-carousel__arrow,
      .el-carousel__arrow--left,
      .el-carousel__arrow--right{
        background: none;
        font-size: 20px;
        color: #828288;
      }
      .el-carousel__button{
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #C0C0C3;
      }
      
      .el-carousel__indicators--horizontal{
        bottom: 105px;
      }
      .el-carousel__item{
        padding: 107px 95px;
        h3{
          font-size: 42px;
          font-weight: 600;
          color: #000000;
          line-height: 50px;
        }
        p{
          margin-top: 52px;
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 38px;
          text-align: justify;
        }
      }
    }
  }
  .cs-Protrain-part6{
    background: #fff;
    color: #000000;
    padding: 86px 0 87px 0;
    .p1{
      font-size: 42px;
      font-weight: 600;
      line-height: 50px;
      text-align: center;
    }
    .p2{
      font-size: 20px;
      font-weight: 400;
      color: #000000;
      line-height: 38px;
      margin: 60px auto 0 auto;
      max-width: 958px;
      text-align: justify;
    }
  }
}
// 适配
@media screen and (max-width: 992px) {
  .Protrain .cs-Protrain-part1 {
    .text-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      .item-5 {
        width: 100% !important;
        img {
          width: 100% !important;
          height: auto !important;
          max-width: 400px !important;
        }
      }
      .word——text {
        width: 100% !important;
        margin-top: 16px;
        .p1 {
          font-size: 20px !important;
          margin: 0 0 15px 0 !important;
        }
        .p2 {
          font-size: 24px !important;
          margin-bottom: 10px;
        }
      }
    }
    .item {
      .item-5 {
        img {
          width: 100% !important;
          max-width: 400px !important;
        }
      }
    }
    .text-column {
      .p1 {
        font-size: 20px !important;
        margin: 0 0 15px 0 !important;
      }
      .p2 {
        font-size: 24px !important;
      }
    }
  }
  .Protrain .cs-Protrain-part3 .item{
    display: grid;
    .grid-content{
      width: 90%!important;
      margin: 20px auto!important;
    }
  }
  .Protrain .cs-Protrain-part4 .item{
    display: grid;
    .item-1,
    .item-2{
      width: 100%;
      margin: 0 auto;
    }
    .item-1{
      text-align: center;
      margin-bottom: 60px;
      img{
        width: 100%;
      }
    }
  }
  .Protrain .cs-Protrain-part5 .container{
    .el-carousel__container{
      height: 500px!important;
    }
    .el-carousel__indicators--horizontal{
      bottom: 50px;
    }
  }
}
</style>
